import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { Logger as AppLogger } from '../lib/utils';
import { getApiBaseUrl, getAuthTokenFromState } from '../lib/httpClient';

// Configuración mejorada con manejo de errores
export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: fetchBaseQuery({
    baseUrl: getApiBaseUrl(),
    credentials: 'include',
    prepareHeaders: (headers, { getState }) => {
      try {
        const token = getAuthTokenFromState(getState());
        if (token) {
          headers.set('authorization', `Bearer ${token}`);
        }
      } catch (error) {
        AppLogger.error('Error accessing auth state in prepareHeaders:', error);
      }
      return headers;
    },
    fetchFn: async (...args) => {
      try {
        return await fetch(...args);
      } catch (error) {
        AppLogger.error('Network fetch error:', error);
        throw error;
      }
    },
  }),
  tagTypes: ['User'],
  keepUnusedDataFor: 300,
  refetchOnMountOrArgChange: 30,
  refetchOnFocus: false,
  refetchOnReconnect: true,
  endpoints: _builder => ({}),
});

export default apiSlice;
